<template lang="pug">
.serverSettings
    v-container
        v-card(light, flat)
            v-card-text
                v-row
                    v-col
                        .text-h5.black--text Settings
                    v-spacer
                    v-col.flex-grow-0.flex-shrink-1
                        v-btn(title='Refresh', icon, dense, color='brand', @click='getCurrentSettings')
                            v-icon refresh
                v-row
                    v-col
                        .text-h6.black--text HubSpot
                v-row
                    v-col
                        v-switch(label='Sync Projects', v-model='allowProjectSync', color='brand', title='When enabled, server will sync SAT project DB with HubSpot')
                        v-switch(label='Write Project Comments', v-model='allowWriteComments', color='brand', title='When enabled, server will write SAT project status to HubSpot Projects as a comment')
                    v-col
                        v-btn.white--text(color='brand', @click='manualDialog = true', :disabled='!allowProjectSync') Manual Sync
                v-row
                    v-col
                        .text-h6.black--text Cloud Backup
                        v-text-field(label='Cloud Server IP', v-model='cloudBackupServerIP', :rules='ipRegexRule', outlined, color='brand', dense)
                v-row
                    v-col
                        .text-h6.black--text Mobile App
                        v-textarea(label='Firebase Service Account', v-model='firebaseServiceAccountKey', outlined, color='brand', dense)

            v-card-actions
                v-spacer
                v-btn.white--text(color='brand', @click='saveChanges', :disabled='!unsavedChanges') Save


        v-dialog(v-model='manualDialog', max-width='450')
            v-card(light)
                v-card-title HubSpot Sync
                v-card-text
                    v-container
                        v-row
                            p.mb-0.pt-4 The following will be synced upon confirmation:
                        v-row.mt-n2(justify='space-around')
                            v-checkbox(label='Sync Projects', v-model='manualProjectSync', color='brand', title='When enabled, server will sync SAT project DB with HubSpot', hide-details)
                            v-checkbox(label='Write Project Comments', v-model='manualCommentSync', color='brand', title='When enabled, server will write SAT project status to HubSpot Projects as a comment', hide-details)
                v-card-actions
                    v-spacer
                    v-btn(text, @click='manualDialog = false') Cancel
                    v-btn.white--text(color='brand', @click='manualUpdate') Sync

    v-overlay(absolute, :value='busy')
        .text-h6 Please Wait...
        v-progress-linear(indeterminate)

    v-snackbar(v-model='showAlert', dark, :timeout='3000') {{ message }}
    
</template>

<script>
import { cloneDeep } from 'lodash';
import ipRegex from 'ip-regex';

export default {
    data () {
        return {
            dti,
            accessKey: 'admin',
            message: '',
            busy: false,
            justify: 'center',
            currentServerSettings: {},
            allowWriteComments: false,
            allowProjectSync: false,
            manualDialog: false,
            manualProjectSync: true,
            manualCommentSync: true,
            cloudBackupServerIP: '0.0.0.0',
            firebaseServiceAccountKey: '',
            ipRegexRule: [value => !value || ipRegex({exact: true}).test(value) || 'Invalid IP Address']
        };
    },
    methods: {
        resetChanges () {
            this.getCurrentSettings();
        },

        async getCurrentSettings () {
            await this.socketEmit('getServerSettings', null, (settings) => {
                this.currentServerSettings = settings;
                this.allowWriteComments = settings.hubspotWriteComments;
                this.allowProjectSync = settings.hubspotSyncProjects;
                this.cloudBackupServerIP = settings.cloudBackupServerIP;
                this.firebaseServiceAccountKey = settings.firebaseServiceAccountKey;
                this.message = 'Refreshed Settings';
            });
        },

        async saveChanges () {
            //Get settings
            const settings = cloneDeep(this.currentServerSettings);
            settings.hubspotSyncProjects = this.allowProjectSync;
            settings.hubspotWriteComments = this.allowWriteComments;
            settings.cloudBackupServerIP = this.cloudBackupServerIP;
            settings.firebaseServiceAccountKey = this.firebaseServiceAccountKey;

            await this.socketEmit('saveServerSettings', settings, ({success}) => {
                if (success) {
                    this.message = 'Server settings updated!';
                    this.currentServerSettings.hubspotSyncProjects = this.allowProjectSync;
                    this.currentServerSettings.hubspotWriteComments = this.allowWriteComments;
                    this.currentServerSettings.cloudBackupServerIP = this.cloudBackupServerIP;
                    this.currentServerSettings.firebaseServiceAccountKey = this.firebaseServiceAccountKey;
                } else {
                    this.message ='There was an error updating the settings.';
                }
            });
        },

        manualUpdate () {
            const options = {
                manualProjectSync: this.manualProjectSync,
                manualCommentSync: this.manualCommentSync
            };

            this.socketEmit('manualHubspotUpdate', options);
            this.manualDialog = false;
            this.message = 'Manual sync began';

            //Reset sync options
            this.manualProjectSync = true;
            this.manualCommentSync = true;
        },

    },
    computed: {
        unsavedChanges () {
            let changes = false;
            if(this.allowProjectSync !== this.currentServerSettings.hubspotSyncProjects) changes = true;
            if(this.allowWriteComments !== this.currentServerSettings.hubspotWriteComments) changes = true;
            if(this.cloudBackupServerIP !== this.currentServerSettings.cloudBackupServerIP) changes = true;
            if(this.firebaseServiceAccountKey !== this.currentServerSettings.firebaseServiceAccountKey) changes = true;
            
            return changes;
        },
        showAlert: {
            get () {
                return this.message !== '';
            },
            set (val) {
                if (val === false) {
                    this.message = '';
                }
            },
        },
        
        
    },
    watch: {

    },
    mounted () {
        window.serversettingsvm = this;
        this.getCurrentSettings();
    }
};
</script>

<style lang="scss" scoped>
</style>

<style lang="scss">
</style>
